module.exports = __webpack_public_path__ + "img/failx.38c1c5ea.svg";